module.exports = __webpack_public_path__ + "img/tank-turret-shadow.241442ac.png";